// src/utils/logger.js
/**
 * Safe logging utility - ไม่ log ใน production
 */

const isDevelopment = process.env.NODE_ENV === "development";

/**
 * Safe console.log - log เฉพาะใน development mode
 */
export function log(...args) {
  if (isDevelopment) {
    console.log(...args);
  }
}

/**
 * Safe console.error - log เฉพาะใน development mode
 */
export function logError(...args) {
  if (isDevelopment) {
    console.error(...args);
  }
  // ใน production อาจส่งไปยัง error tracking service
  // เช่น Sentry, LogRocket, etc.
}

/**
 * Safe console.warn - log เฉพาะใน development mode
 */
export function logWarn(...args) {
  if (isDevelopment) {
    console.warn(...args);
  }
}
